var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showInstallButton)?_c('v-btn',_vm._b({staticClass:"text-none",attrs:{"id":"install-app","color":"primary","depressed":"","dark":""},on:{"click":_vm.installPwa}},'v-btn',_vm.$attrs,false),[_vm._v(" Instalar App ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }